import { render, staticRenderFns } from "./MiddleStatistics-Ex.vue?vue&type=template&id=5f4ad846&scoped=true&"
import script from "./MiddleStatistics-Ex.vue?vue&type=script&lang=js&"
export * from "./MiddleStatistics-Ex.vue?vue&type=script&lang=js&"
import style0 from "./MiddleStatistics-Ex.vue?vue&type=style&index=0&id=5f4ad846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ad846",
  null
  
)

export default component.exports